module.exports = __webpack_public_path__ + "img/4.d2ac001c.jpg";